import React, { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface AppVersionProps {
  className?: string;
}

let cachedVersion: string | null = null;
const listeners = new Set<(v: string) => void>();

export const invalidateVersionCache = (newVersion?: string) => {
  if (newVersion) {
    cachedVersion = newVersion;
    listeners.forEach(fn => fn(newVersion));
  } else {
    cachedVersion = null;
  }
};

const AppVersion: React.FC<AppVersionProps> = ({ className = '' }) => {
  const [version, setVersion] = useState(cachedVersion || '');

  useEffect(() => {
    listeners.add(setVersion);
    if (!cachedVersion) {
      const fetchVer = async () => {
        const { data } = await supabase
          .from('app_version')
          .select('version')
          .eq('id', 'main')
          .single();
        if (data) {
          cachedVersion = data.version;
          setVersion(data.version);
        }
      };
      fetchVer();
    }
    return () => { listeners.delete(setVersion); };
  }, []);

  if (!version) return null;

  return (
    <span className={className}>
      © 2024 Project Tracking System. All rights reserved.
      <br />
      Version {version}
    </span>
  );
};

export default AppVersion;
